// extracted by mini-css-extract-plugin
export default {"root":"IconAdult_root__FNBMt"};